/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .factory('WebPreview', ['$modal', '$httpParamSerializer', '$translate', 'template', 'relativeUrlRootFilter', function ($modal, $httpParamSerializer, $translate, template, relativeUrlRootFilter) {
        return {
            open: function (node, showRevision, showNodeActions) {
                $modal.open({
                    templateUrl: 'nodes/preview',
                    controller: ['$scope', '$modalInstance', 'node',
                        function ($scope, $modalInstance, node) {
                            $scope.modal = $modalInstance.options;
                            $scope.modal.subTitle = showRevision && node.revision ? $translate.instant('Revision') + ' ' + node.revision : null;
                            $scope.node = node;
                            $scope.previewUrl = _buildPreviewUrl(node);
                            $scope.showNodeActions = angular.isDefined(showNodeActions) ? showNodeActions : true;

                            $scope.close = $scope.cancel = function () {
                                $modalInstance.dismiss('cancel');
                            };
                        }
                    ],
                    windowTemplateUrl: template('nodes/preview_window'),
                    resolve: {
                        node: function () {
                            return node;
                        }
                    }
                });
            }
        };

        function _buildPreviewUrl(node) {
            var endpoint = relativeUrlRootFilter('/web_preview/' + node['preview_type'] + '.html');
            var query_string = $httpParamSerializer({
                url: node.actions['preview'],
                name: node.name,
                uuid: node.uuid
            });

            return endpoint + '?' + query_string;
        }
    }]);
